<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 18:21:31
 * @FilePath: 
 * @Description: 会员统计
-->
<template>
  <div class="c-p-t-20 c-p-b-20 full_page_grey statistics_page">
    <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>
    <div class="table_list_con" ref="tablistRef">
      <div
        :class="[{ bigWidth: dateType == 0 || dateType == 1 }, 'smallWidth']"
      >
        <div class="c-f c-ft-25 table_title_con">
          <p class="tc">手机号</p>
          <p class="tc">姓名</p>
          <p class="tc">消费金额</p>
          <p class="tc" v-if="dateType == 0 || dateType == 1">累计消费金额</p>
          <p class="tc">
            {{ dateType == 0 || dateType == 1 ? "累计消费次数" : "消费次数" }}
          </p>
          <p class="tc">
            {{
              dateType == 0 || dateType == 1
                ? "上次消费间隔(天)"
                : "平均消费间隔(天)"
            }}
          </p>
        </div>
        <div class="table_item_con">
          <van-list
            v-model="loading"
            :error.sync="loadError"
            :immediate-check="false"
            :finished="finished"
            :offset="30"
            error-text="请求失败，点击重新加载"
            @load="onShowMore"
          >
            <div class="c-f c-ft-25" v-for="(v, i) in performanceList" :key="i">
              <p class="tc p-tb-15">
                {{ v.MobilePhone }}
              </p>
              <p class="tc p-tb-15">{{ v.MemberName }}</p>
              <p class="tc p-tb-15">{{ v.ConsumeMoney }}</p>
              <p class="tc p-tb-15" v-if="dateType == 0 || dateType == 1">
                {{ v.ConsumeTotal }}
              </p>
              <p class="tc p-tb-15">{{ v.BillCount }}</p>
              <p class="tc p-tb-15">{{ v.Days }}</p>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTabCom from "./comps/dateTabCom.vue";
import { getMemberStatisticsData } from "@/api/performance";
import BScroll from "better-scroll";
export default {
  name: "JishiPerformance",
  props: {},
  data() {
    return {
      dateType: null,
      pageIndex: 0,
      pageSize: 30,
      loading: false,
      finished: false,
      loadError: false,
      performanceList: [],
    };
  },
  components: { DateTabCom },
  created() {},

  mounted() {
    this.$nextTick(() => {
      this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetMemberStatistics();
      this.$nextTick(() => {
        this.tableScroll = new BScroll(this.$refs.tablistRef, {
          click: false,
          scrollX: true,
          scrollY: true,
        });
      });
    });
  },
  methods: {
    handleChangeDateType(type) {
      this.dateType = type;
      console.log(this.tableScroll);
      if (this.tableScroll) {
        this.$nextTick(() => {
          this.tableScroll.refresh();
        });
      }
      if (this.dateType !== 4) {
        this.resetParams();
        this.handleGetMemberStatistics();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.resetParams();
      this.handleGetMemberStatistics();
    },
    resetParams() {
      this.loadError = false;
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.performanceList = [];
    },
    handleGetMemberStatistics() {
      const queryData = {
        Query: {
          TimeType: this.dateType,
          VpnId: this.$store.state.vpnId,
        },
        Pager: {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
        },
      };
      if (this.dateType == 4) {
        queryData.Query.BeginTime = this.startDate;
        queryData.Query.EndTime = this.endDate;
      }
      getMemberStatisticsData(queryData).then((res) => {
        let resDatas = res.Items;
        // this.allPage = res.Pager.TotalPage;
        if (resDatas instanceof Array) {
          this.performanceList = this.performanceList.concat(resDatas);
          if (this.performanceList.length >= res.Pager.TotalCount) {
            this.finished = true;
          }
        }
        this.loading = false;
      });
    },
    // 上拉加载
    onShowMore() {
      console.log(this.loadError);
      // if (this.pageIndex + 1 < this.allPage) {
      this.pageIndex += 1;
      this.handleGetMemberStatistics();
      // }
    },
  },
};
</script>
<style scoped lang="scss">
.statistics_page {
  overflow: hidden;
}
.table_list_con {
  // overflow-x: auto;
  margin: 20px 10px;
  width: 100%;
  .smallWidth {
    width: 1000px;
    &.bigWidth {
      width: 1200px;
    }
  }

  .table_title_con {
    width: 100%;
    height: 70px;
    color: #fff;
    p {
      height: 100%;
      line-height: 70px;
      background: var(--tc);
      &.clock_ticheng_con {
        line-height: 35px;
      }
    }
  }
  p {
    width: 200px;
    flex-shrink: 0;
  }
  .table_item_con {
    background: #fff;
  }
}
</style>
